import { Box, Button, Checkbox, colors, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import React, { useEffect, useState } from 'react';
import logo from '../assets/1_Transparent_Image.png';
import BasicTable from '../components/common/BasicTable';
import apiService from '../api';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DEFAULT_URL } from '../constants';

const Logs: React.FC = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const headersTable = [
    'idlog',
    'user_id',
    'username',
    'action',
    'description',
    'created_at',
  ];

  useEffect(() => {
    fetchData();
  }, []);

  // Create an async function for the HTTP request
  async function fetchData() {
    try {
      const response = await axios({
        method: 'get',
        data: null,
        url: `${DEFAULT_URL}logs`,
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });
      // const response = await apiService.get(null, 'cockpit-client');
      if (response.status > 200) {
        navigate('/signin');
        throw new Error('Network response was not ok');
      }

      const data = await response.data;
      setItems(data);
    } catch (error) {
      console.error(error, 'error fetch');
      navigate('/signin');
    }
  }
  return (
    <div>
      <BasicTable columns={headersTable} items={items} />
    </div>
  );
};

export default Logs;
